import api from '@/apis/cre/cRERepReportSubmitAPI.js';
import Crud from '@/stores/crudBase';

var crud = new Crud('cRERepReportSubmit', api);

const state = {
  ...crud.state,
  _config: {
    table: 'cre_rep_report_submit',
    field: {
      key: 'report_submit_id',
      // code: 'ref_no',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
